import { SystemItemTypes } from "../enums";
import { IAPIItemsGridModel } from "../interfaces"; 
import { PricingPageInputModel } from "./PriceInputs.model";

 
export class ItemGridModel {
    id: string;
    name: string;
    description: string;
    createdDate: Date;
    isActive: boolean;
    hasVariants: boolean;
    isTrackInventory: boolean;
    prices?: PricingPageInputModel[];
    onHandInventory?: number;
    type: keyof typeof SystemItemTypes;
    totalVariants?: number;
    constructor(data?: Partial<ItemGridModel>) {
        this.id = data?.id || '';
        this.name = data?.name || '';
        this.description = data?.description || '';
        this.createdDate = data?.createdDate || new Date();
        this.isActive = data?.isActive || false;
        this.hasVariants = data?.hasVariants || false;
        this.isTrackInventory = data?.isTrackInventory || false;
        this.prices = data?.prices || [];
        this.onHandInventory = data?.onHandInventory;
        this.type = data?.type || (Object.keys(SystemItemTypes)[0] as keyof typeof SystemItemTypes);
        this.totalVariants = data?.totalVariants;
    }

    static deserialize(apiResponse: IAPIItemsGridModel): ItemGridModel {
        if (!apiResponse) return new ItemGridModel();

        const data: Partial<ItemGridModel> = {
            id: apiResponse.id,
            type: apiResponse.type as keyof typeof SystemItemTypes,
            name: apiResponse.name,
            description: apiResponse.description,
            createdDate: new Date(apiResponse.createdDate.replace('Z', '')),
            isActive: apiResponse.isActive,
            hasVariants: apiResponse.hasVariants,
            isTrackInventory: apiResponse.isTrackInventory,
            prices: apiResponse.prices?.map((price) => PricingPageInputModel.deserializeAPIModel(price)) || [],
            onHandInventory: apiResponse.onHandInventory,
            totalVariants: apiResponse.totalVariants,
        };

        return new ItemGridModel(data);
    }
}
